var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-bar" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "touch",
              rawName: "v-touch:moved",
              value: _vm.touchStart,
              expression: "touchStart",
              arg: "moved"
            },
            {
              name: "touch",
              rawName: "v-touch:moving",
              value: _vm.touchMove,
              expression: "touchMove",
              arg: "moving"
            },
            {
              name: "touch",
              rawName: "v-touch:end",
              value: _vm.stopDrag,
              expression: "stopDrag",
              arg: "end"
            }
          ],
          class: ["content", { dragging: _vm.isDragging }],
          style: _vm.wrapperStyle
        },
        [
          _c(
            "tree-menu",
            { attrs: { items: _vm.MENU, "max-depth": 3 } },
            [
              _c(
                "vue-client-only",
                { attrs: { slot: "prepend" }, slot: "prepend" },
                [
                  !_vm.adaptive.isDesktop
                    ? _c(
                        "ul",
                        [
                          _c("mobile-city"),
                          _c(
                            "a",
                            { staticClass: "link", attrs: { href: "/stores" } },
                            [
                              _c("f-sprite-icon", {
                                attrs: {
                                  "icon-link": _vm.$options.icons.IconPoint.id
                                }
                              }),
                              _vm._v("\n            Магазины\n          ")
                            ],
                            1
                          ),
                          _c("mobile-search"),
                          _c("mobile-account")
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _c(
                "vue-client-only",
                {
                  staticClass: "mobile-contacts",
                  attrs: { slot: "append" },
                  slot: "append"
                },
                [
                  !_vm.adaptive.isDesktop
                    ? _c("div", { staticClass: "mobile-contacts" }, [
                        _c("h3", [_vm._v("8 800 770 01 01")]),
                        _c("p", [
                          _vm._v("Мы принимаем звонки с 7:00 до 22:00 (мск).")
                        ]),
                        _c("p", [_vm._v("Звонок по России бесплатный.")])
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.$f.navOpened
          ? _c("div", {
              staticClass: "overlay",
              on: {
                click: function($event) {
                  return _vm.$f.hideNav()
                }
              }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }